import Ruwenzori from './assets/Ruwenzori.avif';
import Ruwenzori2 from './assets/Ruwenzori2.avif';
import slider1 from './assets/slider1.avif';
import slider2 from './assets/slider2.avif';
import slider3 from './assets/slider3.avif';
import chakamt from './assets/Chakamt.jpeg';


const destinations = [
    {
      id: 1,
      image: chakamt,
      title: 'Biking Hells Gate',
      description: 'Description for destination 1.'
    },
    {
      id: 2,
      image: Ruwenzori2,
      title: 'Mt Kenya',
      description: 'Description for destination 2.'
    },
    {
      id: 3,
      image: slider1,
      title: 'Mt Longonot',
      description: 'Description for destination 3.'
    },
    {
      id: 4,
      image: slider2,
      title: 'Destination 4',
      description: 'Description for destination 4.'
    },
    {
      id: 5,
      image: slider3,
      title: 'Chaka Ranch',
      description: 'Description for destination 5.'
    },
  ];

export default destinations